import { defineComponent } from "vue";
import common from "../core/core";
import { VueAutoHeight } from "@/core/vue-auto-height.component";
import { Swiper as SwiperCreator } from "swiper";
import autosuggest from "@/components/autosuggest";

export default defineComponent({
  components: {
    VueAutoHeight,
  },
  data() {
    return {
      addressService: this.$store.direct.getters.addressService,
      tabSwiper: null,
      tabIndex: 0,
      channelsExpanded: [],
      selectedType: window.selectedType as any,
      selectedPackage: window.selectedPackage as any,
      trigger: false,
    };
  },
  mounted() {
    const swiperContainer = this.$refs.swiperContainer as HTMLElement;

    if (swiperContainer) {
      this.tabSwiper = new SwiperCreator(swiperContainer, {
        slidesPerView: 1,
        allowTouchMove: false,
        autoHeight: true,
      });
      this.changeTab(0);
    }

    this.changeDetection();

    window.requestAnimationFrame(this.render);
    window.addEventListener("resize", () => {
      this.changeDetection();
    });
  },
  computed: {},
  methods: {
    changeTab(index: number) {
      const tabs: any = (this.$refs.tabs as HTMLElement)?.querySelectorAll(".tv-channels-tab-item");
      if (tabs?.[index]) {
        this.tabIndex = index;
        const line: any = this.$refs.tabLine as HTMLElement;
        line.style.width = tabs[index].offsetWidth + "px";
        line.style.left = tabs[index].offsetLeft + "px";
      }
      this.tabSwiper?.slideTo(index);
    },
    async toggleExpand(tabSlug: string) {
      if (!this.channelsExpanded.includes(tabSlug)) {
        this.channelsExpanded.push(tabSlug);
        await this.timeout(100);
        this.updateSwiper();
      } else {
        this.channelsExpanded.splice(this.channelsExpanded.indexOf(tabSlug), 1);
        await this.timeout(100);
        this.updateSwiper();
        if (tabSlug != "0") {
          await this.timeout(100);
          const tabsContainer = this.$refs.tabs as HTMLElement;
          tabsContainer.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }
    },
    timeout(ms: number) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async updateSwiper() {
      if (this.tabSwiper) {
        this.tabSwiper.update();
      }
    },
    getChannelsContentStyles(tabSlug: string) {
      let height = null;

      if (this.channelsExpanded.includes(tabSlug)) {
        const container = document.querySelector(`.channel-container-${tabSlug}`);
        height = { "max-height": container.scrollHeight + "px" };
      }

      return height;
    },
    selectType(type: string) {
      this.selectedType = type;
      this.changeDetection();
    },
    selectPackage(tv_package: string) {
      this.selectedPackage = tv_package;
      this.changeDetection();
    },
    getChannelsWrapperClasses(tabSlug: string) {
      const count = document.querySelectorAll(`.channel-item-${tabSlug}.active`).length;
      let max = 18;

      if (window.innerWidth <= 1199 && window.innerWidth > 767) {
        max = 12;
      } else if (window.innerWidth <= 767) {
        max = 6;
      }

      return {
        "hide-shadow": this.channelsExpanded.includes(tabSlug),
        "element-enough": count <= max,
      };
    },
    render() {
      if (this.tabSwiper) {
        this.tabSwiper.update();
      }

      //window.requestAnimationFrame(this.render);
    },
    changeDetection() {
      setTimeout(() => {
        this.toggleExpand("0");
      }, 1);
    },
  },
  mixins: [common, autosuggest],
});
